import React, { useEffect, useState } from 'react';
import BatterTable from './BatterTable';
import ballImage from '../../assets/img/icon/ball_icon.png';
import {useCookies} from 'react-cookie';
import dateSetting from '../../utils/dateSetting';
import axios from 'axios';
import _ from 'lodash';
import { flatObject } from '../../utils/flat';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';

function BatterTableWrapper({title, id, column, profile, season}) {
    const [cookies] = useCookies(['hiball_token']);
    let [pitcherType, setPitcherType] = useState('total');
    let [tableData, setTableData] = useState([]);
    let dateObj = dateSetting();
    const { t } = useTranslation();

    const ballSortArr = [
        {code: 'fastBall', type: '직구'},
        {code: 'twoSeam', type: '투심'},
        {code: 'cutter', type: '커터'},
        {code: 'curve', type: '커브'},
        {code: 'slider', type: '슬라'},
        {code: 'changeUp', type: '체인'},
        {code: 'fork', type: '포크'},
    ];

    useEffect(() => {
        let {playerId} = profile;
        
        let params = {
            batterIds: playerId,
            seasons: season,
            gameTypeCode: 4201,
            authToken:JSON.stringify(cookies['hiball_token']),
            recordType: 'digestBattingRecord'
        };

        if(column === 'ballCode') {
            params['recordName'] = 'selectPitchTableRecord';
        } else if(column === 'count') {
            params['recordName'] = 'selectCountSituationRecord';
        } else { //runnerType
            params['recordName'] = 'selectRunnerTypePitchSituationRecord';
        }

        if(pitcherType !== 'total') {
            if(pitcherType === 'R') {
                params['pitchingForms'] = 801;
                params['pitchingHands'] = 'R';
            } else if(pitcherType === 'L') {
                params['pitchingForms'] = 801;
                params['pitchingHands'] = 'L';
            } else { //side
                params['pitchingForms'] = '802,803,804';
            }
        }

        axios({
            url : `${process.env.REACT_APP_API_URL}`,params
        }).then(result => {
            let innerData = result['data']['result'];

            if(column === 'ballCode') {
                let ballCodeArr = [];

                _.forEach(ballSortArr, (item, idx) => {
                    let ballTypeObj = innerData[item['code']];
                    let ballData = ballTypeObj[0];
                    let ballObj = flatObject(ballData);

                    ballObj['type'] = item['type'];
                    ballObj['ballCode'] = item['code'];
                    ballObj['groupingType'] = 'ballCode';
                    ballCodeArr.push(ballObj);
                });

                setTableData(ballCodeArr);
            } else {
                let newArr = _.map(innerData, (item) => {
                    return flatObject(item);
                })

                setTableData(newArr);
            }
        })
    }, [pitcherType]);

    function pitcherTypeHandler(event) {
        let value = event.target.value;
        setPitcherType(value);
    }

    return (
        <>
        <div className="tableBox">
            <div className="tableTitle">
                <img src={ballImage} alt='#'/> {title}
                <span id={id+"_stat"}></span>
            </div>
            <div style={{position:'relative'}} className="table_select_div">
                <div style={{position:'absolute', top:'-40px', right: '10px'}}>
                    <div className="formTitle">{t('pitcherThrows')}</div>
                    <Form.Group onChange={pitcherTypeHandler} style={{display:'inline-block'}}>
                        <Form.Select size="sm">
                            <option value="total">{t('all')}</option>
                            <option value="R">{t('throwRight')}</option>
                            <option value="L">{t('throwLeft')}</option>
                            <option value="S">{t('throwSideOrUnder')}</option>
                        </Form.Select>
                    </Form.Group>
                </div>
            </div>
            <div className="tableDiv">
                <BatterTable data={tableData} column={column}/>
            </div>
        </div>
        </>
    )
}

export default BatterTableWrapper;